import { useCallback, useEffect, useState } from 'react'
import { Alert, Box, Button, Card, CardActions, CardContent, Chip, Pagination, Stack, Typography, useTheme } from '@mui/material'
import apiClient from '../../utils/apiClient'
import requestStore from '../../stores/requestStore'
import { requestColorStyles } from '../../theme/requestColorTokens'
import { archiveOutcomeLabel } from '../../utils/requestLifecycleUi'
import organizationSessionStore from '../../stores/organizationSessionStore'

export default function ArchivedRequests() {
  const theme = useTheme()
  const [requests, setRequests] = useState([])
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [error, setError] = useState('')
	const generation = organizationSessionStore.contextGeneration

  const load = useCallback(async (nextPage = page) => {
    try {
      setError('')
      const response = await apiClient.get('/requests/archive/list', { params: { page: nextPage, limit: 30 } })
      setRequests(response.data.requests)
      setTotalPages(Math.max(response.data.pagination.totalPages, 1))
    } catch (loadError) {
		setRequests([])
		setTotalPages(1)
      setError(loadError.response?.data?.message || 'Не удалось загрузить архив')
    }
  }, [page])

  useEffect(() => {
		setRequests([])
		setTotalPages(1)
		load(page)
	}, [load, page, generation])

  const restore = async request => {
    try {
      await requestStore.restoreRequest(request.id)
      await load(page)
    } catch (restoreError) {
      setError(restoreError.message)
    }
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Архив заявок</Typography>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {!requests.length && <Typography color="text.secondary">Архив пуст.</Typography>}
      <Stack spacing={1.5}>
        {requests.map(request => {
          const colors = requestColorStyles(request.colorToken, theme.palette.mode)
          return (
            <Card key={request.id} variant="outlined" sx={{ bgcolor: colors?.background, color: colors?.text, borderColor: colors?.border }}>
              <CardContent>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                  <Typography variant="subtitle1">{request.title}</Typography>
                  <Chip size="small" color={request.outcome === 'WON' ? 'success' : (request.outcome === 'LOST' ? 'error' : 'default')} label={archiveOutcomeLabel(request.outcome)} />
                  {request.sourceName && <Chip size="small" variant="outlined" label={request.sourceName} />}
                </Box>
                {request.description && <Typography variant="body2" sx={{ mt: 1 }}>{request.description}</Typography>}
                <Typography variant="caption" display="block" sx={{ mt: 1 }}>В архиве с {new Date(request.archivedAt).toLocaleString()}</Typography>
                {request.closedAt && <Typography variant="caption" display="block">Закрыта {new Date(request.closedAt).toLocaleString()}</Typography>}
              </CardContent>
              <CardActions>
                <Button onClick={() => restore(request)}>Восстановить в ту же колонку</Button>
              </CardActions>
            </Card>
          )
        })}
      </Stack>
      {totalPages > 1 && <Pagination sx={{ mt: 2 }} page={page} count={totalPages} onChange={(_, nextPage) => setPage(nextPage)} />}
    </Box>
  )
}
